module.exports = __webpack_public_path__ + "media/images/fixed-resized-e39a861e695714cc6b435dfa030d14f5.svg";